import { render } from "./user.vue?vue&type=template&id=4d528920&scoped=true&ts=true"
import script from "./user.vue?vue&type=script&lang=ts"
export * from "./user.vue?vue&type=script&lang=ts"

import "./user.vue?vue&type=style&index=0&id=4d528920&lang=less&scoped=true"

import exportComponent from "/Users/zhaoliang/Desktop/vue3-webim/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d528920"]])

export default __exports__